<fuse-drawer
  class="ista-vertical-navigation"
  [@enterAnimation]
  [mode]="(isSmallScreen$ | async) ? 'over' : 'side'"
  [name]="'leftDrawer'"
  [opened]="expanded()"
  [transparentOverlay]="false"
  (openedChanged)="onDrawerToggled($event)"
>
  <div class="ista-sidenav">
    <a class="flex justify-center" [routerLink]="['/welcome']">
      <img
        alt="istaConnect"
        class="max-h-[80px] max-w-[222px]"
        [fallbackSrc]="'/assets/img/ista_Logo_Connect_horizontal_OceanBlue_RGB.png?rev=' + assetsRev"
        [src]="brandLogo() + '?rev=' + assetsRev"
      />
    </a>

    <div class="px-4 pb-4 pt-1">
      <ic-main-navigation />
    </div>
  </div>
</fuse-drawer>

<section>
  <mat-toolbar class="ista-ui-header md-whiteframe-z1">
    <button
      class="mdc-icon-button mat-mdc-icon-button mat-unthemed mat-mdc-button-base ml-1"
      mat-icon-button
      (click)="toggleDrawer()"
    >
      <mat-icon class="icon-size-6">menu</mat-icon>
    </button>
    @if (!expanded()) {
      <a class="flex justify-center" [@enterAnimation] [routerLink]="['/welcome']">
        <img
          alt="istaConnect"
          class="max-h-[80px] max-w-[222px]"
          [fallbackSrc]="'/assets/img/ista_Logo_Connect_horizontal_OceanBlue_RGB.png?rev=' + assetsRev"
          [src]="brandLogo() + '?rev=' + assetsRev"
        />
      </a>
    }
    <div class="w-full">
      <ic-top-navigation class="flex flex-row justify-end p-4" />
    </div>
  </mat-toolbar>

  @if (breadcrumb$ | async; as breadcrumb) {
    <section>
      <ic-breadcrumb [configuration]="breadcrumb" />
    </section>
  }
  <main>
    <ic-inline-notification />
    <ng-content />
    <router-outlet />
  </main>

  <footer>
    <ic-app-footer [isBranded]="isBranded()" />
  </footer>

  <div class="flex-cookies flex-sticky-cookies">
    <ic-accept-cookies class="accept-cookies" language="{{ (locale$ | async)?.lang }}" />
  </div>
</section>

<ic-spinner />
<ic-toasts />
